var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 37 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: ".5", width: "36", height: "36", rx: "9", fill: "#FF6B00" }),
    React.createElement("path", { d: "M18.5 25.424l5.335 3.377c.977.618 2.172-.296 1.915-1.453l-1.414-6.349 4.718-4.277c.861-.78.399-2.26-.733-2.354l-6.209-.552-2.43-5.999a1.264 1.264 0 0 0-2.365 0l-2.43 5.986-6.208.551c-1.131.094-1.594 1.574-.733 2.354l4.718 4.277-1.414 6.35c-.257 1.156.938 2.07 1.915 1.452l5.335-3.363z", fill: "#FFDB19" })
  );
});